import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showWaitingAreaAfterCallsModal } from '../../../../actions/modal';
import { updateAfterCallDetail } from '../../../../actions/waitingArea';
import { forceValidation } from '../../../../businessLogic/validation.js';

export default function RightPanelUpdate(props) {
  const dispatch = useDispatch();
  const [updatingBeforeCallsDetail, setUpdatingBeforeCallsDetail] = useState(false);

  const updateAfterCallDetailWithInComponent = () => {
    setUpdatingBeforeCallsDetail(true);
    let cb = (showModal) => {
      setUpdatingBeforeCallsDetail(false);
      dispatch(showWaitingAreaAfterCallsModal(showModal));
    };
    dispatch(updateAfterCallDetail(props.waitingArea.id, props.afterCallsForm, cb));
  };

  const saveModalChange = (event) => {
    let areThereErrors = forceValidation(undefined, undefined, 'afterCallsForm');
    if (!areThereErrors && !window.$(event.target).hasClass('disable')) {
      updateAfterCallDetailWithInComponent();
    }
  };

  const cancelUpdateWaitingArea = () => {
    dispatch(showWaitingAreaAfterCallsModal(false));
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull';
  return (
    <div>
      {props.updateOrView == 'update' ? (
        <div className="mrtxxs mrbl max-width">
          <button
            tabIndex="4"
            type="button"
            onClick={saveModalChange}
            data-group="afterCallsForm"
            className={updatingBeforeCallsDetail ? saveClasses + ' loading' : saveClasses}
          >
            {APP.LANGUAGE.Save}
            <i className="checkmark icon" />
          </button>
          <button
            tabIndex="5"
            type="button"
            onClick={cancelUpdateWaitingArea}
            className="ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Cancel}
          </button>
        </div>
      ) : (
        <div className="mrbl max-width mrtxxs ">
          <button
            onClick={cancelUpdateWaitingArea}
            className="ui cancel  labeled icon button color-bad-things color-bad-things-hover color-white   max-width left-text mrlnull mrbnull"
          >
            <i className="remove  icon" />
            {APP.LANGUAGE.Close}
          </button>
        </div>
      )}
    </div>
  );
}
